import { rescheduleEvaluation } from '@modules/EvaluationModule/helpers/rescheduleEvaluation';
import { rescheduleEval } from '@modules/EvaluationModule/redux/evaluationsManegment/actions';
import { updateGoogleCalendarEvalAction } from '@modules/EvaluationModule/redux/googleCalendarEval/actions';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DataState } from '@shared/enums/DataState';
import { SortDirection } from '@shared/enums/sortDirection';
import { MainPageState } from './types';
import { SortInfo } from '@shared/interfaces/sortInfo';
import { EvalSortFields } from '../enums/EvalSortFields';

const initialState: MainPageState = {
  myPeopleEvalData: {
    data: null,
    state: DataState.Pending,
  },
  myPeopleEvalTotal: null,
  startingEvalId: '',
  locations: {
    data: null,
    state: DataState.Pending,
  },
  managersData: {
    data: null,
    state: DataState.Pending,
  },
  membersData: {
    data: null,
    state: DataState.Pending,
  },
  sortInfo: { field: EvalSortFields.Date, sortDirection: SortDirection.Asc },
};

export const slice = createSlice({
  name: 'myPeopleEvalPage',
  initialState,
  reducers: {
    setMyPeopleEvalDataLoading(state) {
      state.myPeopleEvalData = { data: null, state: DataState.Pending };
      state.myPeopleEvalTotal = null;
    },
    setMyPeopleEvalData(state, action) {
      state.myPeopleEvalData = action.payload;
    },
    setMyPeopleEvalTotal(state, action: PayloadAction<number>) {
      state.myPeopleEvalTotal = action.payload;
    },
    setStartingEvalId(state, action) {
      state.startingEvalId = action.payload;
    },
    setAllLocationsDataLoading(state) {
      state.locations = { data: null, state: DataState.Pending };
    },
    setAllLocationsData(state, action) {
      state.locations = action.payload;
    },
    setManagersLoading(state) {
      state.managersData = { data: null, state: DataState.Pending };
    },
    setManagersData(state, action) {
      state.managersData = action.payload;
    },
    setMembersLoading(state) {
      state.membersData = { data: null, state: DataState.Pending };
    },
    setMembersData(state, action) {
      state.membersData = action.payload;
    },
    setSortInfo(state, action: PayloadAction<SortInfo>) {
      state.sortInfo = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(rescheduleEval, (state, { payload }) => {
      if (!state.myPeopleEvalData.data) {
        return;
      }
      state.myPeopleEvalData.data = state.myPeopleEvalData.data.map((item) =>
        item.evaluationId === payload.evaluationId
          ? rescheduleEvaluation({ rescheduledEval: item, rescheduleData: payload })
          : item
      );
    });

    builder.addCase(updateGoogleCalendarEvalAction, (state, { payload }) => {
      if (!state.myPeopleEvalData.data) {
        return;
      }
      const evalToUpdate = state.myPeopleEvalData.data.find((d) => d.evaluationId === payload.evaluationId);
      if (!evalToUpdate) {
        return;
      }
      evalToUpdate.googleCalendarEvent = payload.googleCalendarEvent;
    });
  },
});

export const {
  setMyPeopleEvalData,
  setMyPeopleEvalDataLoading,
  setMyPeopleEvalTotal,
  setStartingEvalId,
  setAllLocationsDataLoading,
  setAllLocationsData,
  setManagersLoading,
  setManagersData,
  setMembersLoading,
  setMembersData,
  setSortInfo,
} = slice.actions;

export default slice.reducer;
